export default __webpack_public_path__ + "static/media/womenMantoo.7c04032e.svg";